import { Container } from "react-grid-system";
import styled from "styled-components";

export const StyledUnit = styled(Container)`
	margin-top: 2.4rem;
`;
